import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
import Preloader from "../../components/Preloader/Preloader";
import MUIDataTable from "mui-datatables";

// Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// Components
import PurchaseOrderReceiptTable from "./PurchaseOrderReceiptTable"; //reused table component
import ReceiptIcon from '@material-ui/icons/Receipt';
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import MessageBox from "../../components/MessageBox/MessageBox";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
import LoadingModal from "../../components/Modal/LoadingModal";
import {isLoggedIn} from "../../components/Cookies/Cookies";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const getMuiTheme = () => createMuiTheme({
	overrides: {
	  MUIDataTableHeadCell: {
		root: {
		  '&:nth-child(1)': {
			width: 120
		  },	
		  '&:nth-child(2)': {
			width: 120
		  },
		  '&:nth-child(3)': {
			width: 160
		  },
		  '&:nth-child(4)': {
			width: 160
		  },
		}
	  }
	}
  });

const PurchaseOrderPaymentForm = () => {
	const { chkno, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState([]);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [notes, setNotes] = useState('');

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);
	const [dataLoaded, setDataLoaded] = useState(false);

	const [poAllocationItems, setPoAllocationItems] = useState([]);
	const [showModal, setShowModal] = useState(false);

	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);
//

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'po_payment_allocate_form', {
			params:{
				chkno: chkno,
				jc_u_idno: branchidno
			}
		}).then(function (response) {
			setItems(response.data.data[1].item_info);
			setSupplierInfo(response.data.data[0].po_info);
			// setShipTotal(response.data.data[0].supplier_info.shipping);
			// setWarehouse(response.data.data[0].supplier_info.warehouse_id);
			setDataLoaded(true);
			// setPoTotal(response.data.data[0].supplier_info.subtotal);
			// setGrandTotal(response.data.data[0].supplier_info.total);
			// setNotes(response.data.data[0].supplier_info.notes);
		}).catch((error)=>{
			setDataLoaded(true);
			// console.log(error.message);
		});
		//setTotal(parseInt(poTotal) + parseInt(shipTotal));
		
	};	

	const updateItems = (recAmount, pono, balance) => {
		let found = poAllocationItems.some(x => x.pono === pono);
		if(found){
			//if item is existing in itemArray, add the qty instead
			let newItems = poAllocationItems.map((it)=> {
				if(it.pono === pono){ //add
					it.allocated_value = parseFloat(recAmount);
					//update the allocated amount if it is existing in the state array
				  }
			  return it;
			});
			setPoAllocationItems(newItems);
		}else{
			setPoAllocationItems([...poAllocationItems, 
				//add the new object in the array (for PO allocation)
				{
					pono: pono,
					ponoamount: balance,
					allocated_value : parseFloat(recAmount)
				}
			]);
		}	
	}
	const removeItem = (pono) => {
		let newItems = poAllocationItems.filter((it)=>{
			return (it.pono !== pono);
		})
		setPoAllocationItems(newItems);
	}

	//function amountAllocatePOPayment(count,unpaidamount)
	function amountAllocatePOPayment(e,unpaidamount,pono)
	{
		//var fieldID = 'popay'+count;
		var recAmount = e.target.value;
		var fieldrun = 'popay';
		var checkbalance = parseFloat(supplierInfo.balance);
	    var grandtotal = supplierInfo.grandtotal;
	    // var checkbalance = document.getElementById("checkbalance").value; checkbalance=checkbalance.replace(/#/ig,"").replace(/&/ig,"").replace(/'"/ig,"");
	    // var grandtotal = document.getElementById("grandtotal").value; grandtotal=grandtotal.replace(/#/ig,"").replace(/&/ig,"").replace(/'"/ig,"");
	    //var recAmount = document.getElementById(fieldID).value; recAmount=recAmount.replace(/#/ig,"").replace(/&/ig,"").replace(/'"/ig,"");
	    var diff=0;
	
	    let checker=1;
	    if (recAmount === "")
	    {
			// document.getElementById(fieldID).value=0;
			e.target.value=0;
			removeItem(pono);
	    }
	    else
	    {
	        if(parseFloat(recAmount) || (recAmount===0))
	        {
	           if (recAmount>unpaidamount)
	           {
	                checker = 3;
			   }
			   updateItems(recAmount, pono, unpaidamount);
	        }
	        else
	        {
				//document.getElementById(fieldID).value=0;
				e.target.value=0;
				removeItem(pono);
	        }
	    }
	
	    if (checker==1)
	    {      
	        var totalamt=0;
	        for(var a=1; a<=grandtotal; a++)
	        {
	            fieldrun = 'popay'+a;
	            var val = document.getElementById(fieldrun).value;
	            totalamt = (totalamt*1)+(val*1);
	        }
		
	        diff = (checkbalance*1)-(totalamt*1);
		    
	        if (diff>=0)
	        {
	            if(totalamt===0)
	            {
					//document.getElementById("allocateBtn").disabled = true;
					setBtnDisabled(true); 
	            }
	            else
	            {
					setBtnDisabled(false); 
	                //document.getElementById("allocateBtn").disabled = false;
	            }
			
	            //totalamt = number_format(totalamt, 2, '.', ','); 
	            //setText('allocLabel',totalamt);
	        }
	        else
	        {
				setShowMsgBox(true);
				setMsg("ERROR: You have insufficient balance for allocation.");
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(true); // re-enable
				}, 2500)
				e.target.value=0;
				removeItem(pono);
	        }
	    }
	    else if (checker===3) 
	    {
			setShowMsgBox(true);
			setMsg("ERROR: allocated amount exceeds the unpaid amount.");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(true); // re-enable
			}, 2500)
			e.target.value=0;
			removeItem(pono);
	    }
	    else
	    {
			setShowMsgBox(true);
			setMsg("ERROR: Please make sure all values entered are correct.");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(true); // re-enable
			}, 2500)
			e.target.value=0;
			removeItem(pono);
	    }
	
	}
	// const getCheckBalance = () => {
	// 	let total = 0;
	// 	items.forEach(item => {
	// 		total += item.balance;
	// 	});
	// 	return total;
	// }

	const po_payment_allocate = async () => {
		// const checkbalance = getCheckBalance();
		const checkbalance = supplierInfo.balance;
		
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		formData.append("item_array", JSON.stringify(poAllocationItems));
		formData.append("jc_u_idno", branchidno);
		formData.append("chkno", chkno);
		formData.append("checkbalance", checkbalance);
	  
		await axios.post(process.env.REACT_APP_API_URL+'po_payment_allocate', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("PO Payment Allocate Success");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/account/check-view-reference/'+chkno+'/'+branchidno);
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				// console.log(error);
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	const columns = [
		{
			name: "date",
			label: "Date",
			options: {
				//filter: false,
				// display: "excluded",
			},
		},
		{
			name: "pono",
			label: "PO No.",
			options: {
				filter: true,
				sortDirection: 'desc',
			}
		},
		{
			name: "balance",
			label: "balance",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},
		{
			name: "balance",
			label: "Amount",
			options: {
				customBodyRenderLite: (dataIndex) => {
					let count =  items[dataIndex].count;
					let balance =  items[dataIndex].balance;
					let pono =  items[dataIndex].pono;
// $echo.='<input value="0" onchange="amountAllocatePORet('.$count.','.$unpaidamount.');" type="text" id="poret'.$count.'" name="poret'.$count.'" >';
					// let allocateall =  items[dataIndex].allocateall;
					return(
						// <Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<TextField 
									classes={classes.rightTxt}
									placeholder="Enter amount to allocate" 
									// inputProps={{ 'aria-label': 'Amount' }} 
									inputProps={{
										style: { textAlign: "right" },
										'aria-label': 'Amount' 
									  }}
									defaultValue="0"
									type="number"
									id={"popay"+count}
									fullWidth
									onBlur={(e)=> amountAllocatePOPayment(e,balance, pono)}
									// onChange={e => setuseridNo(e.target.value)}
							/>
						
					);
				}
			}
		},
	];

	const options = {
		//hide toolbar functions
		toolbar:false,
		filter: false,
		viewColumns: false,
		search: false,
		download: false,
		print: false,
		csv: false,
		pagination: false,
		// filterType: "dropdown",
		selectableRows: "none",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<NavLink to={"/purchases"}><h2 style={{color:"black"}}>Purchases</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/purchases/purchases-order-payment"}><h2 style={{color:"black"}}>Purchase Order Payment</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Purchase Order Payment Allocate #{chkno}</h2>
				{/* <h2>supplier id: {supid} - delivery_date: {delivery_date}</h2> test if param values were passed*/}
			</div>
			<div className="page-container">
				<LoadingModal showModal={showModal}/>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={12}>
								<div className={classes.subTitle}>
								{"Purchase Order Payment Allocate"}
								</div>
								<div className={classes.title}>
									{supplierInfo.title || "Purchase Order Payment Allocate"}
								</div>
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={1} className={classes.infoTitle}>
									Total
								</Grid>
								<Grid
									item
									xs={11}
									className={classes.infoContent}
								>
									{numeral(supplierInfo.total).format('0,0.00') || "Total"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={1} className={classes.infoTitle}>
									Balance
								</Grid>
								<Grid
									item
									xs={11}
									className={classes.infoContent}
								>
									{numeral(supplierInfo.balance).format('0,0.00') || "Balance"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={1} className={classes.infoTitle}>
									Allocation
								</Grid>
								<Grid
									item
									xs={11}
									className={classes.infoContent}
								>
									{numeral(supplierInfo.allocation).format('0,0.00') || "Allocation"}
								</Grid>
							</Grid>
						</div>

						{!dataLoaded ? (
							<Preloader />
						) : (
							<MuiThemeProvider theme={getMuiTheme()}>
								<MUIDataTable
									title={
										<div>
											<div className="table-subtitle">Table</div>
											<div className="table-title">
											Purchase Order Payment Form
											</div>
										</div>
									}
									data={items}
									columns={columns}
									options={options}
								/>
						  </MuiThemeProvider>
						)}
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
					<Button disabled={btnDisabled} variant="contained" color="primary" onClick={po_payment_allocate}>
					Allocate Now
					</Button>
				</div>
			</div>
		</div>
	);
};

export default PurchaseOrderPaymentForm;
